// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 600px) {
  .sidebar-inside {
    display: none;
    visibility: hidden;
  }
}
/*# sourceMappingURL=documents-form.component.css.map */`, "",{"version":3,"sources":["webpack://./documents-form.component.less","webpack://./src/app/documents/documents-form/documents-form.component.less"],"names":[],"mappings":"AAEA;EACA;IACI,aAAA;IACA,kBAAA;ECDF;AACF;AACA,uDAAuD","sourcesContent":["@import (reference) \"../../../assets/less/colors.less\";\n\n@media (max-width: 600px) {\n.sidebar-inside {\n    display: none;\n    visibility: hidden;\n}\n}\n\n","@media (max-width: 600px) {\n  .sidebar-inside {\n    display: none;\n    visibility: hidden;\n  }\n}\n/*# sourceMappingURL=documents-form.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
